import { Card, Text, Group, Badge, SimpleGrid, ThemeIcon, Stack } from '@mantine/core';
import { companionGroups, plants } from '../data/plants';

const GROUP_COLORS = ['green', 'orange', 'violet', 'cyan', 'pink', 'yellow'];

interface CompanionViewProps {
  isSelected: (name: string) => boolean;
}

export function CompanionView({ isSelected }: CompanionViewProps) {
  return (
    <Stack gap="lg">
      <Text size="sm" c="dimmed">
        Classic companion planting groups for Mapleton, UT. Plants that grow well together
        share nutrients, repel pests, or provide structural support.
      </Text>

      <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="md">
        {companionGroups.map((group, i) => {
          const color = GROUP_COLORS[i % GROUP_COLORS.length];
          return (
            <Card key={group.name} shadow="sm" padding="lg" radius="md" withBorder>
              <Group gap="sm" mb="sm">
                <ThemeIcon color={color} variant="light" size="lg" radius="xl">
                  <Text size="sm" fw={700}>{group.plants.length}</Text>
                </ThemeIcon>
                <Text fw={600} size="md">{group.name}</Text>
              </Group>

              <Group gap={6} mb="sm">
                {group.plants.map((name) => (
                  <Badge key={name} color={color} variant={isSelected(name) ? 'filled' : 'outline'} size="sm">
                    {name}
                  </Badge>
                ))}
              </Group>

              <Text size="sm" c="dimmed">{group.description}</Text>

              {/* Show avoid info for plants in this group */}
              {(() => {
                const avoids = group.plants.flatMap((pName) => {
                  const plant = plants.find((p) => p.name === pName);
                  if (!plant || plant.avoid.length === 0) return [];
                  return plant.avoid.map((a) => `${pName} ✗ ${a}`);
                });
                const unique = [...new Set(avoids)];
                if (unique.length === 0) return null;
                return (
                  <Group gap={4} mt="xs">
                    <Text size="xs" c="red.6" fw={500}>Avoid nearby:</Text>
                    {unique.slice(0, 3).map((a) => (
                      <Badge key={a} size="xs" variant="light" color="red">{a}</Badge>
                    ))}
                  </Group>
                );
              })()}
            </Card>
          );
        })}
      </SimpleGrid>
    </Stack>
  );
}
